import React from 'react';
import { useReveal } from '../../hooks/useReveal';

export default function About() {
  const ref = useReveal(0.12);

  return (
    <section className="section section--alt" id="about" ref={ref}>
      <div className="container">
        <div className="about__grid">

          {/* Photo */}
          <div className="about__photo-outer reveal">
            <div className="about__photo-frame">
              <img src="images/profile_pic.jpg" alt="Dhruvin Patel" loading="lazy" />
            </div>
            <div className="about__photo-decor" aria-hidden="true" />
          </div>

          {/* Text */}
          <div className="about__text">
            <span className="label reveal reveal-delay-1">About Me</span>
            <h2 className="section-title reveal reveal-delay-2">
              Building at the intersection of data &amp; engineering
            </h2>

            <p className="about__bio reveal reveal-delay-3">
              I'm a Senior ML leader with 6+ years of experience building intelligent
              systems across the property and mortgage industry. Currently leading
              Machine Learning Science at Cotality, I specialize in computer vision,
              deep learning, and scalable ML platforms — bridging cutting-edge research
              with production-grade impact.
            </p>

            <p className="about__bio reveal reveal-delay-3" style={{ marginTop: '14px' }}>
              My career spans the full arc from software engineering to data science to
              ML leadership at CoreLogic/Cotality, with hands-on work building transformer
              models, ResNets, U-Nets, and microservice integrations that power real-world
              property intelligence at scale.
            </p>

            <div className="about__stats reveal reveal-delay-4">
              <div className="stat">
                <span className="stat__number">6+</span>
                <span className="stat__label">Years Exp.</span>
              </div>
              <div className="stat">
                <span className="stat__number">2</span>
                <span className="stat__label">Degrees</span>
              </div>
              <div className="stat">
                <span className="stat__number">ML</span>
                <span className="stat__label">Leader</span>
              </div>
            </div>

            <div className="about__cta reveal reveal-delay-5">
              <a
                href="/others/resume_dhruvinpatel.pdf"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn--outline"
              >
                <i className="fa fa-download" aria-hidden="true" />
                Download Resume
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
